import { extend } from "vee-validate";
import { required, email, min, numeric, alpha } from "vee-validate/dist/rules";
import i18n from '@/i18n'
extend("required", {
  ...required,
  message: i18n.t('input.validation.required')
});

extend("email", {
  ...email,
  message: i18n.t('input.validation.email')
});

extend("min", {
  ...min,
  message: i18n.t('input.validation.min')
});
extend("numeric", {
  ...numeric,
  message: i18n.t('input.validation.numeric')
});
extend("password", {
  validate: (value, { other }) => value === other,
  message: i18n.t('input.validation.password'),
  params: [{ name: "other", isTarget: true }]
});

extend("alpha", {
  ...alpha,
  message: i18n.t('input.validation.alpha')
});
